import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class ArchiveTypeSelector extends Component{

	archiveTypeSelectClass = 'archive-type-list__item';

	handleClick = (type,e) => {
		e.preventDefault();
		this.props.changeType(type);
	};

	renderTypeSelector = (type, index) => {
		const {products} = this.props;
		if(!products.some(x => x.type === type.name) || type.name.includes('NO_CATEGORY'))
			return;

		return (
			<li onClick={(e) => this.handleClick(type.name, e)} className={this.getClassByType(type.name)} key={index}>
				<FormattedMessage id={'archive.type.' + type.name}/>
			</li>
		);
	};

	getClassByType = (type) => {
		const {rendered} = this.props;
		return rendered === type
			? this.archiveTypeSelectClass + ' active'
			: this.archiveTypeSelectClass;
	};

	render(){
		const {itemTypes} = this.props;
		return(
			<ul className="archive-type-list">
				<li className={this.getClassByType('ALL')} onClick={(e) => this.handleClick('ALL', e)} >
					<FormattedMessage id={'archive.type.ALL'}/>
				</li>
				{itemTypes.map((type, index) => this.renderTypeSelector(type, index + 1))}
			</ul>
		);
	};
}

export default ArchiveTypeSelector;


// WEBPACK FOOTER //
// ./src/components/common/ArchiveTypeSelector.js